import { normalizeArray, pow } from './svgUtils'
import { NormalDistribution } from 'js-stats'

const norm = new NormalDistribution(0, 1)
/*
    array must contain normalized values in [0, 1]
*/
export function cutSilence(
  array,
  silenceThreshold = 0.2,
  targetSilencePercentages = [0.1, 0.1]
) {
  let volumeStart = 0
  let averagedArray = runningAverage(array)
  while (averagedArray[volumeStart] < silenceThreshold) {
    volumeStart++
  }

  let volumeEnd = array.length - 1
  while (averagedArray[volumeEnd] < silenceThreshold) {
    volumeEnd--
  }

  const volumeLength = volumeEnd - volumeStart

  let cutFrontUntil = volumeStart - volumeLength * targetSilencePercentages[0]
  let cutEndUntil = volumeEnd + volumeLength * targetSilencePercentages[1]

  cutFrontUntil = Math.max(0, cutFrontUntil)
  cutEndUntil = Math.min(array.length, cutEndUntil)
  const result = expandArray(
    array.slice(cutFrontUntil, cutEndUntil),
    array.length
  )
  return result
  //return averagedArray
  //return Array.prototype.slice.call(array)
}

function expandArray(array, length) {
  const result = []
  for (let i = 0; i < length; i++) {
    result[i] = linearInterpolate(array, i / length)
  }
  return result
}

function linearInterpolate(array, percentage) {
  const length = array.length - 1
  const atZero = array[Math.floor(percentage * length)]
  const atOne = array[Math.ceil(percentage * length)]

  // we translate the percentage from [0,1] to [-1,1]
  const val = (percentage * length - Math.floor(percentage * length)) * 2 - 1
  const perc = logisticSigmoid(val)

  return atZero * perc + atOne * (1 - perc)
}

function logisticSigmoid(val) {
  if (val < -1 || val > 1) throw new Error('val must be between 0 and 1')

  return 1 / (1 + Math.pow(Math.E, -5 * val))
}

function runningAverage(array, windowLength = 0.05) {
  windowLength = Math.floor(windowLength * array.length)
  const halfLength = Math.floor(0.5 * windowLength)
  const result = []
  let window = []

  for (let i = 0; i < array.length; i++) {
    if (i + halfLength < array.length) {
      window.push(array[i + halfLength])
    } else {
      window.push(0)
    }
    const sum = fastSum(
      array,
      Math.max(0, i - halfLength),
      Math.min(i + halfLength, array.length)
    )
    result.push(sum / windowLength)
  }
  return normalizeArray(result, 1, 0)
}

function fastSum(array, from, to) {
  let sum = 0
  for (let i = from; i < to; i++) {
    sum += array[i]
  }
  return sum
}

function toPercentile(arr) {
  const sortableArray = arr.map((v, i) => {
    return {
      value: v,
      id: i,
    }
  })
  const sortedArray = sortableArray.sort((a, b) => a.value - b.value)
  sortedArray.forEach(({ id }, rank) => {
    arr[id] = rank / arr.length + 0.5 / arr.length
  })
  return arr
}
// We calculate their percentile rank and then use the inverse cumulative probability to make them normal distributed
export function normalDistribute(original, strength = 1, silenceThreshold = 0) {
  // get all values that do not display silence
  const nonsilentOriginals = original.filter((o) => o > silenceThreshold)
  if (nonsilentOriginals.length === 0) {
    throw new Error('Recording is completely silent')
  }
  // 1. Get the percentile rank of all nonsilent values (e.g [0.1, 0.9, 0.2] will become [0.25, 0.75, 0.5])
  // 2. This is a Gleichverteilung
  // 3. Turn the Gleichverteilung into a Standardnormalverteilung (e.g. 0.5 will become 0)
  // 4. Normalize the array to contain values between 0 and 1 again
  // 5. Turn the normalverteilung into an exponentialverteilung, making the value distribution more extreme
  const normalized = pow(
    normalizeArray(
      toPercentile(nonsilentOriginals).map((p) =>
        norm.invCumulativeProbability(p)
      )
    ),
    4
  )
  const final = []

  // Readd the silent values to the array
  let silentIdOffset = 0
  let i = 0
  for (i = 0; i < normalized.length; i++) {
    while (original[silentIdOffset + i] <= silenceThreshold) {
      final.push(original[i + silentIdOffset++])
    }
    final.push(
      strength * normalized[i] + original[silentIdOffset + i] * (1 - strength)
    )
  }
  while (original[silentIdOffset + i] <= silenceThreshold) {
    final.push(original[i + silentIdOffset++])
  }
  if (final.length != original.length) {
    throw new Error('length changed!')
  }
  return final
  //return original
}
